import { AppContext } from "@components/features/appContext/AppContext";
import Icon from "@components/primitives/icon/Icon";
import useFetchYoutubeVideos from "@hooks/youtube/useFetchYoutubeVideos";
import { translation } from "@utils/translation";
import { YoutubeType } from "next-lib";
import { useContext } from "react";

function Video() {
  const { language } = useContext(AppContext);
  const { youtubeVideos } = useFetchYoutubeVideos(language);

  return (
    <div className="bg-secondary p-5 w-full shadow-lg grid gap-5 grid-rows-1 row-start-2 row-end-3 col-start-1 col-end-2">
      <div>
        <h1 className="text-xl mb-5 font-bold flex items-center gap-5">
          <Icon icon="youtube" prefix="fab" />
          {translation(language).home.informations.latestVideo.title}
        </h1>

        <p className="text-secondary text-md">
          {youtubeVideos ? (
            youtubeVideos?.length > 0 ? (
              youtubeVideos?.map((video: YoutubeType) => {
                return (
                  <div className="embed-responsive embed-responsive-16by9 relative w-full overflow-hidden aspect-video p-5">
                    <iframe
                      title={video.snippet.title}
                      className="embed-responsive-item absolute top-0 right-0 bottom-0 left-0 w-full aspect-video pt-5"
                      src={`https://www.youtube.com/embed/${video.id.videoId}`}
                      allowFullScreen
                      data-gtm-yt-inspected-2340190_699="true"
                      id="240632615"
                    />
                  </div>
                );
              })
            ) : (
              <div className="embed-responsive embed-responsive-16by9 relative w-full overflow-hidden aspect-video p-5 bg-tertiary flex justify-center items-center">
                {translation(language).general.error.noDataFound}
              </div>
            )
          ) : (
            <div className="embed-responsive embed-responsive-16by9 relative w-full overflow-hidden aspect-video p-5 bg-tertiary flex justify-center items-center">
              {translation(language).general.error.somethingWentWrong}
            </div>
          )}
        </p>
      </div>
    </div>
  );
}

export default Video;
